/**
 * Okul kademe 1 — route seviyesi org.type kapıları (2026-08-27).
 *
 * Menü daraltması (Sidebar) tek başına yetmez: URL'yi elle yazan ya da eski bir
 * yer iminden gelen okul personeli B2B sayfalarını yine açabilirdi. Bu kapı
 * B2B-özel route'ları okul org'unda /school'a düşürür; index route da okul
 * org'unda Genel Bakış yerine doğrudan Okul sayfasına gider (login sonrası
 * kullanıcı ilk iş olarak öğrenci listesini görür).
 *
 * Fail-open yönü bilinçli: org henüz yüklenmemişken (null) B2B davranışı
 * korunur — /me senkronu org.type'ı getirdiği anda yönlendirme devreye girer.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuthStore } from '@/shared/stores/authStore';

/** B2B'ye özel sayfa: okul org'unda /school'a yönlendirir. */
export function B2bOnlyRoute({ children }: { children: ReactNode }) {
  const org = useAuthStore((s) => s.org);
  if (org?.type === 'school') return <Navigate to="/school" replace />;
  return <>{children}</>;
}

/** Index route: okul org'unda Genel Bakış yerine Okul sayfası. */
export function HomeRoute({ children }: { children: ReactNode }) {
  const org = useAuthStore((s) => s.org);
  if (org?.type === 'school') return <Navigate to="/school" replace />;
  return <>{children}</>;
}
